import { useState } from "react";
import EditDisability from "./EditDisability";
import NewDisabilityForm from "./NewDisabilityForm";
import { AiOutlinePlus } from "react-icons/ai";
import { useGetDisabilities } from "../../../../../services/disabilities.service";
import useUserStore from "../../../../../state-management/useUserStore";
import { DisabilitiesDto } from "../../../../../models/disabilities.dto";
import { SkewLoader } from "react-spinners";
import CustomPagination from "../../../../../components/table/CustomPagination";
import { useManageTableWithStateVariables } from "../../../../../helpers/useManageTable";
import { useCheckUserPermissions, PermissionChecker, PERMISSIONS } from "../../../../../helpers/usePermissionManager";

const Disabilities = () => {
	const { currentUser } = useUserStore();
	const { checkUserPermissionsAnd } = useCheckUserPermissions();
	const [showNewDisabilityForm, setShowNewDisabilityForm] = useState(false);
		
	const {
		tableData: disabilities,
		isLoading,
		page,
		pageCount,
		addNewData,
		reloadData,
		handlePageChange,
	} = useManageTableWithStateVariables<DisabilitiesDto>({ 
		fetchHook: useGetDisabilities,
		options: {
			organizationId: currentUser.user.organizationId,
			limit: 8,
		}
	});
	
	return (
		<div className="mb-4">
			<div className="border-b-[1.5px] pb-3 mb-4 flex w-full justify-between text-sm">
				<h2 className="font-semibold">Available Disablities</h2>
				{!showNewDisabilityForm && (
					<PermissionChecker permissions={[PERMISSIONS.ORG_CONFIGS_COMPANY_WRITE]}>
						<button
							onClick={() => setShowNewDisabilityForm(true)}
							className="border-none flex items-center text-primary-blue"
						>
							<AiOutlinePlus className="mr-2 text-lg" />
							Add New Disability
						</button>
					</PermissionChecker>
				)}
			</div>

			{showNewDisabilityForm && (
				<NewDisabilityForm 
					setShowNewDisabilityForm={setShowNewDisabilityForm}
					addNewData={addNewData}
				/>
			)}

			{(isLoading && !disabilities.length && checkUserPermissionsAnd([PERMISSIONS.ORG_CONFIGS_COMPANY_READ])) && (
				<div className="text-center mt-10 py-10">
					<SkewLoader color="#F58B00" />
				</div>
			)}
	
			{disabilities.map((disability) => (
				<EditDisability 
					key={disability.id}
					disability={disability} 
					reloadData={reloadData}
				/>
			))}

			{(!isLoading && !disabilities.length && checkUserPermissionsAnd([PERMISSIONS.ORG_CONFIGS_COMPANY_READ])) && (
				<div>
					<h3 className="text-center text-sm font-semibold mt-10">
						Sorry no disabilities added yet. Click 'Add New Disability' to begin.
					</h3>
				</div>
			)}

			{checkUserPermissionsAnd([PERMISSIONS.ORG_CONFIGS_COMPANY_READ]) ? (
				<div className="w-full flex justify-end my-8">
					<CustomPagination 
						pageCount={pageCount} 
						pageState={page}
						handleChange={handlePageChange}
					/>
				</div>
			):(
				<div>
					<h3 className="text-center text-sm font-semibold mt-10">
						You are not authorized to access this data.
					</h3>
				</div>
			)}
		</div>
	);
};

export default Disabilities;
